import React from 'react';
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        padding: "30px",
        lineHeight: 1.6,
    },
    title: {
        fontSize: 25,
        marginVertical: "10px",
    },
})

export default function PdfDocument({ data, date }) {
    const hommes = data.invites.filter((invite) => invite.sexe === "homme");
    const femmes = data.invites.filter((invite) => invite.sexe === "femme");
    const maxHommes = data.max_hommes;
    const maxFemmes = data.max_femmes;
    return (
        <Document>
            <Page style={styles.page}>
                <Text style={styles.title}>{date}</Text>
                <View>
                    <Text style={styles.title}>Hommes ({hommes.length}/{maxHommes})</Text>
                    {hommes ? 
                        hommes.map((invite, idx) => (
                            <Text key={idx}>{invite.prenom + " " + invite.nom}</Text>
                        ))
                        :
                        null
                    }
                </View>
            </Page>
            <Page style={styles.page}>
                <View>
                    <Text style={styles.title}>Femmes ({femmes.length}/{maxFemmes})</Text>
                    {femmes ? 
                        femmes.map((invite, idx) => (
                            <Text key={idx}>{invite.prenom + " " + invite.nom}</Text>
                        ))
                        :
                        null
                    }
                </View>
            </Page>
        </Document>
    );
}